import { get, post } from "./_base";

const signIn = (data) => {
  return post("/signIn", data);
};

const logout = () => {
  return post("/logout");
};

const signUp = (data) => {
  return post("/signUp", data);
};

const validateSignUpCode = (data) => {
  return post("/validateSignUpCode", data);
};

const validatePasswordRecovery = (data) => {
  return post("/validatePasswordRecovery", data);
};

const refreshToken = () => {
  return post("/refreshToken");
};

const passwordRecovery = (data) => {
  return post("/passwordRecovery", data);
};

export {
  signIn,
  logout,
  signUp,
  validateSignUpCode,
  validatePasswordRecovery,
  refreshToken,
  passwordRecovery,
};
